import { cookies, headers } from "next/headers";
import { getClientRequestUrl } from "./get-client-request-url";

type ReadonlyHeaders = Awaited<ReturnType<typeof headers>>;
type ReadonlyRequestCookies = Awaited<ReturnType<typeof cookies>>;

export const toExpressQuery = (
  searchParams: URLSearchParams,
): Record<string, string | string[]> => {
  const query: Record<string, string | string[]> = {};

  for (const [key, value] of searchParams.entries()) {
    if (query[key] === undefined || query[key] === null) {
      query[key] = value;
    } else if (Array.isArray(query[key])) {
      (query[key] as string[]).push(value);
    } else {
      query[key] = [query[key] as string, value];
    }
  }

  return query;
};

export const buildExpressRequestFromNextRequest = async (
  reqHeaders: ReadonlyHeaders,
  reqCookies: ReadonlyRequestCookies,
) => {
  const url = await getClientRequestUrl(reqHeaders);
  const searchParams = new URL(url).searchParams;
  const query = toExpressQuery(searchParams);

  const headers = Object.fromEntries(reqHeaders.entries()) as Record<
    string,
    string
  >;
  const cookies: Record<string, string> = Object.fromEntries(
    reqCookies.getAll().map(({ name, value }) => [name, value]),
  );

  const get = (name: string) => {
    return reqHeaders.get(name);
  };

  return {
    request: {
      headers,
      url,
      query,
      get,
      cookies,
    },
  };
};
